import { createContext } from 'react';

/**
 * Context for bidirectional navigation between the chat view and plugin tabs
 * (e.g. the Axon event viewer). Provided by AgentStreamView so that plugin
 * tab components and chat bubbles can switch views with event highlighting.
 */
export interface StreamViewNavigation {
  showInAxonView: (eventId: string) => void;
  showInChatView: (eventId?: string) => void;
}

export const AxonViewContext = createContext<StreamViewNavigation | null>(null);
